import React, { useEffect, useCallback, useState, useMemo } from 'react';
import { Redirect } from 'react-router-dom';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import FilterListIcon from '@material-ui/icons/FilterList';
import {
	colors, Button, TextField, Typography,
	Grid, Select, Card, CardHeader, CardContent,
	Divider, Accordion, AccordionSummary, Checkbox,
	AccordionDetails, FormControlLabel, Tabs, Tab,
	FormControl, FormGroup
} from '@material-ui/core';
import { Page, Header, Map, SelectField, Label, SearchBar, FiltersDrawer } from 'components';
import { enqueueSnackbar } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';
import { SetFormState, GetRepositoryFiles } from '../../actions/RepositoryPdfActions';
import PdfUpload from './components/PdfUpload';
import PdfTable from './components/PdfTable';
import PdfViewer from './components/PdfViewer';

// import file from '../test.pdf';

// const file = 'data:application/pdf;base64,${prescription}';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const RepositoryForm = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.repositoryReducer.formState);
	const filesInfo = useSelector((state) => state.repositoryReducer.filesInfo);
	const pdfInformationBase64 = useSelector((state) => state.repositoryReducer.pdfInformationBase64);
	const userId = useSelector(state => state.session.user.id);

	const { filename } = formState.values;

	const pdfInformationBase64Complete = `data:application/pdf;base64,${pdfInformationBase64}`;

	const tabs = [
		{ value: 'General', label: 'General' },
		{ value: 'FailuresPreCampaign', label: 'Failures Pre-Campaign' },
		{ value: 'PreCampaign', label: 'Pre-Campaign' },
		{ value: 'AreaOptimisation', label: 'Area Optimisation' },
		{ value: 'SiteOptimization', label: 'Site Optimisation' },
		{ value: 'ContinuousMonitoring', label: 'Continuous Monitoring' },
		{ value: 'DeepAnalysis', label: 'Deep Analysis' }
	];

	const [tab, setTab] = useState('General');

	const getData = useCallback(() => {
		dispatch(GetRepositoryFiles(userId, tab));
	}, []);

	useEffect(() => {
		getData();
	}, []);

	const handleTabsChange = (event, value) => {
		setTab(value);
		dispatch(GetRepositoryFiles(userId, value));
	};
	if (!tab) {
		return <Redirect to="/home" />;
	}

	if (!tabs.find((t) => t.value === tab)) {
		return <Redirect to="/errors/error-404" />;
	}

	let pdfSelected = true;

	if (pdfInformationBase64 === '') {
		pdfSelected = false;
	}

	return (
		<div className={classes.fields}>
			<Grid container spacing={4}>
				<Grid item md={12} xs={12}>
					<Card>
						{/* <CardHeader
							title="Technology"
						/>
						<Divider /> */}
						<CardContent>
							{/* New row */}
							<Grid container spacing={4}>
								<Grid item md={12} x>
									<PdfUpload stream={tab} />
								</Grid>
							</Grid>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
			<Grid container spacing={4}>
				<Grid item md={12}>
					<Card>
						{/* <CardHeader
							title="Technology"
						/>
						<Divider /> */}
						<CardContent>
							{/* New row */}
							<Grid container spacing={4}>
								<Grid item md={5}>
									<Tabs
										className={classes.tabs}
										onChange={handleTabsChange}
										scrollButtons="auto"
										value={tab}
										variant="scrollable"
									>
										{tabs.map((t) => (
											<Tab key={t.value} label={t.label} value={t.value} />
										))}
									</Tabs>
									<Divider className={classes.divider} />
									<div className={classes.content}>
										{tab === 'General' && <PdfTable data={filesInfo} stream={tab} />}
										{tab === 'FailuresPreCampaign' && <PdfTable data={filesInfo} stream={tab} />}
										{tab === 'PreCampaign' && <PdfTable data={filesInfo} stream={tab} />}
										{tab === 'AreaOptimisation' && <PdfTable data={filesInfo} stream={tab} />}
										{tab === 'SiteOptimization' && <PdfTable data={filesInfo} stream={tab} />}
										{tab === 'ContinuousMonitoring' && <PdfTable data={filesInfo} stream={tab} />}
										{tab === 'DeepAnalysis' && <PdfTable data={filesInfo} stream={tab} />}
									</div>
								</Grid>
								<Grid item md={7} hidden={!pdfSelected}>
									<PdfViewer pdf={pdfInformationBase64Complete} filename={filename} />
								</Grid>
								<Grid item md={7} hidden={pdfSelected}>
									<h2>Select a pdf</h2>
								</Grid>
							</Grid>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
		</div>
	);
};

export default RepositoryForm;
